import { render, staticRenderFns } from "./cancelCollectDia.vue?vue&type=template&id=46e3003a&scoped=true&"
import script from "./cancelCollectDia.vue?vue&type=script&lang=js&"
export * from "./cancelCollectDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e3003a",
  null
  
)

export default component.exports